import { render, staticRenderFns } from "./physiotherapy.vue?vue&type=template&id=8881be08&"
import script from "./physiotherapy.vue?vue&type=script&lang=js&"
export * from "./physiotherapy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports